// kfe-circular-progress.js — circular progress indicator.
//
// PORT TARGET: Classes/KFEModules/Reports/ChartViews/KFECircularProgressView.swift
//              and KFELessonPieView in iOS / pie cells in Unity.
//
// One SVG circle whose stroke-dasharray length encodes the progress.
// value: 0..1.

import { KFEComponent } from "../core/component.js";
import { html } from "../core/html.js";

export class KFECircularProgress extends KFEComponent {
  static props = ["value", "label"];
  static styles = `
    :host { display: inline-block; width: 64px; height: 64px; position: relative; }
    svg { width: 100%; height: 100%; transform: rotate(-90deg); }
    .track { stroke: var(--kfe-border); fill: none; stroke-width: 6; }
    .bar { stroke: var(--kfe-accent); fill: none; stroke-width: 6; stroke-linecap: round; }
    .label { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
             font-size: 0.85rem; color: var(--kfe-fg); }
  `;

  render() {
    const v = Math.max(0, Math.min(1, Number(/** @type {any} */ (this).value) || 0));
    const r = 28, c = 2 * Math.PI * r;
    const ns = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(ns, "svg");
    svg.setAttribute("viewBox", "0 0 64 64");
    const track = document.createElementNS(ns, "circle");
    track.setAttribute("class", "track"); track.setAttribute("cx", "32"); track.setAttribute("cy", "32"); track.setAttribute("r", String(r));
    const bar = document.createElementNS(ns, "circle");
    bar.setAttribute("class", "bar"); bar.setAttribute("cx", "32"); bar.setAttribute("cy", "32"); bar.setAttribute("r", String(r));
    bar.setAttribute("stroke-dasharray", `${c * v} ${c}`);
    svg.appendChild(track); svg.appendChild(bar);
    return html`${svg}<div class="label">${/** @type {any} */ (this).label ?? Math.round(v * 100) + "%"}</div>`;
  }
}
